/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 21.10.21
 *
 */
import cytoscape from '@qwoach/cytoscape'
import clone from 'just-clone'
import {findLineTypeItemByLineType} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/cyeditor-edit-elements/LineTypeItem";
import GenogramCustomConnectionsSyncManager from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramCustomConnectionsSyncManager";
import {
	getGenogramConnectionCategoryByEdgeData,
	GenogramConnectionCategoryEnum,
} from "@shared/Genogram/GenogramConnectionCategoryEnum";
import {
	buildSocialConnectionRoute,
	getSocialConnectionSegments,
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramSocialConnectionGeometryHelper";
// console.log(cytoscape('properties'))
let CanvasRenderer = cytoscape('renderer', 'canvas')

const MULTI_LINE_DISTANCE = 2.5
const ARROW_BASE_SIZE = 4
const FAMILY_SYMBOL_SIZE = 8
const EDGE_LABEL_TOP_MARGIN = 26
const LEGEND_HOVER_DIM_OPACITY = 0.18
const CUSTOM_CONNECTION_RENDER_MANAGER_SCRATCH_KEY = "_qwCustomConnectionRenderManager"
const CUSTOM_CONNECTION_RENDER_CONFIG_RESOLVER_SCRATCH_KEY = "_qwCustomConnectionRenderConfigResolver"

let GenogramRenderer = function (options) {
	CanvasRenderer.call(this, options)
}

GenogramRenderer.prototype = clone(CanvasRenderer.prototype)

// Object.keys(BaseRenderer.prototype).forEach(function (key) {
// 	delete GenogramRenderer.prototype[key]
// })
// console.log('BaseRenderer.prototype = ', BaseRenderer.prototype)

// GenogramRenderer.prototype = {
// 	...GenogramRenderer.prototype,
//
// 	register(cytoscape) {
// 		// setupPrototype()
// 		cytoscape('renderer', 'genogramRenderer', GenogramRenderer)
// 	},
//
// }

// function setupPrototype () {

GenogramRenderer.prototype = {
	...GenogramRenderer.prototype,


	drawNode(context, node, shiftToOriginWithBb, drawLabel = true, shouldDrawOverlay = true, shouldDrawOpacity = true){

		// console.log("GenogramRenderer.drawNode: node = ", node)

		// context.save()
		//
		// let isActive = node.selected() || node.active()
		//
		// if(!isActive){
		// 	context.globalAlpha = 0.1
		// }
		//entry for cache
		// CRp$1.drawCachedElementPortion = function (context, ele, eleTxrCache, pxRatio, lvl, reason, getRotation, getOpacity) {

		CanvasRenderer.prototype.drawNode.call(this, context, node, shiftToOriginWithBb, drawLabel, shouldDrawOverlay, shouldDrawOpacity)

		let {tempElement, isAuxNode, tags} = node.data()
		// console.log("drawNode: tags = ", tags)
		if(tempElement || isAuxNode){
			return
		}

		let shiftXY = {x: 0, y: 0}

		if(!shiftToOriginWithBb){
			shiftXY.x = node.position().x - node.outerWidth() / 2
			shiftXY.y = node.position().y - node.outerHeight() / 2
		}



		this.drawHealthConditions(context, node, shiftXY)
		// this.drawNodeLabels(context, node, shiftXY)
		this.drawOverlaySigns(context, node, shiftXY)


		// context.restore()
	},

	drawEdgePath(edge, context, pts, type) {
		let curveSubStyle = edge.data().lineSubType
		// let hasActiveNodes = edge.source().selected() || edge.target().selected() || edge.selected()
		// context.save()
		// let globalAlpha = context.globalAlpha
		// // console.log("drawEdgePath: edge = ", edge, ", curveSubStyle = ", curveSubStyle, ", hasActiveNodes = ", hasActiveNodes, ", globalAlpha = ", globalAlpha)
		//
		// if(!hasActiveNodes){
		// 	context.globalAlpha = 0.1
		// }
		// console.log("drawEdgePath: context.globalAlpha = ", context.globalAlpha)
		// let curveStylePev = edge.data().lineTypePrev || null
		// var rs = edge._private.rscratch
		// if (curveSubStyle !== curveStylePev) {
		//   rs.pathCacheKey = null
		// }

		if (curveSubStyle) {
			return this.drawGenogramEdgePath(edge, context, pts, type, curveSubStyle)
		} else {
			CanvasRenderer.prototype.drawEdgePath.call(this, edge, context, pts, type)
		}
		// context.globalAlpha = 1//globalAlpha
		// context.restore()
	},

	// drawNodeOverlay(){
	//
	// },
	// drawNodeUnderlay(){
	//
	// },

	// drawRoundRectanglePath(context, x, y, width, height){
	//
	//
	// },

	// drawElementText(){
	//
	// },

	// drawRoundRectanglePath(){
	//
	// },

	findEdgeControlPoints(edges) {
		let bezierEdges = []
		let otherEdges = []

		edges.forEach(edge => {
			if(edge.data().lineType === "bezier"){
				bezierEdges.push(edge)
			} else {
				otherEdges.push(edge)
			}
		})

		if(bezierEdges.length){
			this.findEdgeControlPoints(otherEdges, bezierEdges)
			this.findEdgeControlPointsBezier(bezierEdges)
		}

		edges = otherEdges
		CanvasRenderer.prototype.findEdgeControlPoints.call(this, edges)

		if (edges && edges.length > 0) {
			for (let i = 0; i < edges.length; i++) {
				let edge = edges[i];
				// console.log("findEdgeControlPoints: edge.data() = ", edge.data())
				let {lineSubType} = edge.data()
				if (this.getEdgeConnectionCategory(edge.data()) === GenogramConnectionCategoryEnum.SOCIAL) {
					this.findSocialConnectionPoints(edge)
				}
			}
		}

		// findEdgeControlPoints(){

	},

	findEdgeControlPointsBezier(bezierEdges){
		CanvasRenderer.prototype.findEdgeControlPoints.call(this, bezierEdges)
		// bezierEdges.forEach(edge => {
		// 	var _p = edge._private;
		// 	var rs = _p.rscratch;
		// 	// let edgeType = rs.edgeType
		// 	// rs.segpts = _p.rstyle.bezierPts
		// 	// _p.rstyle.bezierPts = null//_p.rstyle.linePts;
		// 	rs.edgeType = "segments"
		// 	// this.storeAllpts(edge)
		// 	this.storeEdgeProjections(edge)
		// 	rs.edgeType = edgeType
		// 	// _p.rstyle.bezierPts = null//_p.rstyle.linePts;
		// })
	},



	findSocialConnectionPoints(edge) {
		let route = buildSocialConnectionRoute({
			sourceNode: edge.source(),
			targetNode: edge.target(),
			familyLineOffsetY: Number(edge.data().familyLineOffsetY) || 0,
		})
		if(!route){
			return
		}

		var rs = edge._private.rscratch
		rs.startX = route.startX
		rs.startY = route.startY
		rs.segpts = route.segmentPoints
		rs.endX = route.endX
		rs.endY = route.endY

		this.checkForInvalidEdgeWarning(edge)
		this.storeAllpts(edge)
		this.storeEdgeProjections(edge)
		this.calculateArrowAngles(edge)
		this.recalculateEdgeLabelProjections(edge)
		this.calculateLabelAngles(edge)
	},

	recalculateEdgeLabelProjections(edge){
		CanvasRenderer.prototype.recalculateEdgeLabelProjections.call(this, edge)
		this.offsetEdgeLabelProjection(edge)
	},

	offsetEdgeLabelProjection(edge){
		if(this.getEdgeConnectionCategory(edge.data()) === GenogramConnectionCategoryEnum.SOCIAL){
			return
		}

		let _p = edge._private
		let rs = _p.rscratch
		let rstyle = _p.rstyle
		let angle = rs.labelAutoAngle
		let labelHeight = rs.labelHeight || rstyle.labelHeight
		if(angle == null || !labelHeight){
			return
		}

		let offset = labelHeight / 2 + EDGE_LABEL_TOP_MARGIN
		let offsetX = Math.sin(angle) * offset
		let offsetY = -Math.cos(angle) * offset
		let labelX = rs.labelX + offsetX
		let labelY = rs.labelY + offsetY

		rs.labelX = labelX
		rs.labelY = labelY
		rstyle.labelX = labelX
		rstyle.labelY = labelY
	},

	drawGenogramEdgePath(edge, context, pts, type, curveSubStyle) {
		let customConnectionRenderManager = edge.cy?.()?.scratch?.(CUSTOM_CONNECTION_RENDER_MANAGER_SCRATCH_KEY) || null
		let customConnectionRenderConfigResolver = edge.cy?.()?.scratch?.(CUSTOM_CONNECTION_RENDER_CONFIG_RESOLVER_SCRATCH_KEY) || null
		if(GenogramCustomConnectionsSyncManager.isCustomLineSubType(curveSubStyle)){
			return this.drawCustomConnectionEdgePath(edge, context, pts, customConnectionRenderManager, customConnectionRenderConfigResolver)
		}
		let lineType = findLineTypeItemByLineType(curveSubStyle)
		let lineStyle = clone(lineType.lineStyle)
		lineStyle.primaryStyle = lineStyle.primaryStyle || {}
		lineStyle.secondaryStyle = lineStyle.secondaryStyle || {}
		lineStyle.isSelected = edge.selected()
		lineStyle.primaryStyle.isSelected = lineStyle.isSelected
		lineStyle.secondaryStyle.isSelected = lineStyle.isSelected

		var canvasCxt = context
		if(edge.hasClass?.("legend-hover-dim")){
			lineStyle.primaryStyle.opacity = LEGEND_HOVER_DIM_OPACITY
			lineStyle.secondaryStyle.opacity = LEGEND_HOVER_DIM_OPACITY
		}

		let i = 0

		if(this.getEdgeConnectionCategory(edge.data()) === GenogramConnectionCategoryEnum.SOCIAL){
			this.drawFamilyRelationship(canvasCxt, lineStyle, edge)
			return
		}

		let isOriented = lineStyle.isOriented
		while (i < pts.length - 2) {

			lineStyle.isOriented = isOriented && i === pts.length - 4

			// console.log("drawGenogramEdgePath: i = ", i, ", curveSubStyle = ", curveSubStyle, ", pts.length = ", pts.length)

			let x1 = pts[i], y1 = pts[i + 1], x2 = pts[i + 2], y2 = pts[i + 3]
			i += 2

			let angle = Math.atan2((y2 - y1), (x2 - x1))
			let a = x2 - x1
			let b = y2 - y1
			let lineLength = Math.sqrt(a * a + b * b)

			switch (curveSubStyle) {

				case 'straight':
					this.drawSingleLine(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'adopted':
					this.drawSingleLine(canvasCxt, this.lineStyleDashedPrimary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'foster':
					this.drawSingleLine(canvasCxt, this.lineStyleDottedPrimary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'immigration':
					this.drawImmigrationPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'multicultural':
					this.drawMulticulturalPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'indifferent':
					this.drawSingleLine(canvasCxt, this.lineStyleDottedPrimary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'distant':
					this.drawSingleLine(canvasCxt, this.lineStyleDashedPrimary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'cutoff':
					this.drawGappedPath(canvasCxt, this.lineStyleDashedPrimary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'discord':
					this.drawDoubleLine(canvasCxt, this.lineStyleDashedSecondary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'hate':
					this.drawTripleLine(canvasCxt, this.lineStyleDashedSecondary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'harmony1':
					this.drawSingleLine(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'harmony2':
					this.drawDoubleLine(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'harmony3':
					this.drawVerticalLinesWithDoubleLine(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'harmony4':
					this.drawCircledPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'harmony5':
					this.drawDoubleCircledPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'hostile1':
					this.drawSingleZigZagPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'hostile2':
					this.drawZigZagWithSingleLine(canvasCxt, this.lineStyleDashedSecondary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'hostile3':
					this.drawZigZagWithDoubleLine(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'hostile4':
					this.drawZigZagWithTripleLine(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'hostile5':
					this.drawVerticalLinesWithSingleLine(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'violence1':
					this.drawSingleZigZagPath(canvasCxt, this.lineStyleZigZagPrimary(lineStyle, 5), x1, y1, lineLength, angle)
					break
				case 'violence2':
					this.drawZigZagWithSingleLine(canvasCxt, this.lineStyleZigZagPrimary(this.lineStyleDashedSecondary(lineStyle), 5), x1, y1, lineLength, angle)
					break
				case 'violence3':
					this.drawZigZagWithDoubleLine(canvasCxt, this.lineStyleZigZagPrimary(lineStyle, 5), x1, y1, lineLength, angle)
					break
				case 'violence4':
					this.drawZigZagWithTripleLine(canvasCxt, this.lineStyleZigZagPrimary(lineStyle, 5), x1, y1, lineLength, angle)
					break
				case 'violence5':
					this.drawTripleLine(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'abuse1':
					this.drawSingleZigZagPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'abuse2':
					this.drawZigZagWithSingleLine(canvasCxt, this.lineStyleDashedSecondary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'abuse3':
					this.drawSingleZigZagPath(canvasCxt, this.lineStyleZigZagPrimary(lineStyle, 5, 5), x1, y1, lineLength, angle)
					break
				case 'abuse4':
					this.drawDoubleZigZagPath(canvasCxt, this.lineStyleZigZagPrimary(lineStyle, 5, 5), x1, y1, lineLength, angle)
					break
				case 'abuse5':
					this.drawSingleLine(canvasCxt, this.lineStyleDashedPrimary(lineStyle), x1, y1, lineLength, angle)
					break
				case 'manipulative':
					this.drawCrossedPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'controlling':
					this.drawSquaredCrossedPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'focused-on':
					this.drawOrientedLinePath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'admirer':
					this.drawCircledPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break
				case 'limerence':
					this.drawDoubleCircledPath(canvasCxt, lineStyle, x1, y1, lineLength, angle)
					break

			}
		}
		// }
	},

	drawCustomConnectionEdgePath(edge, context, pts, customConnectionRenderManager, customConnectionRenderConfigResolver){
		let customConnectionRenderConfig = typeof customConnectionRenderConfigResolver === "function"
			? customConnectionRenderConfigResolver(edge.data().lineSubType)
			: null
		if(!customConnectionRenderManager || !customConnectionRenderConfig){
			return
		}
		if(this.getEdgeConnectionCategory(edge.data()) === GenogramConnectionCategoryEnum.SOCIAL){
			return this.drawCustomSocialConnectionEdgePath(edge, context, customConnectionRenderManager, customConnectionRenderConfig)
		}
		this.drawCustomEdgeWithHoverState(context, edge, () => {
			let i = 0
			while (i < pts.length - 2) {
				let x1 = pts[i]
				let y1 = pts[i + 1]
				let x2 = pts[i + 2]
				let y2 = pts[i + 3]
				let isLastSegment = i >= pts.length - 4
				i += 2
				customConnectionRenderManager.drawConnectionSegment(context, customConnectionRenderConfig, {
					x1,
					y1,
					x2,
					y2,
					isSelected: edge.selected(),
					showDirectionalArrow: isLastSegment,
				})
			}
		})
	},

	drawCustomSocialConnectionEdgePath(edge, context, customConnectionRenderManager, customConnectionRenderConfig) {
		let marriageLineType = findLineTypeItemByLineType("family-marriage")
		let verticalLineStyle = marriageLineType?.lineStyle?.secondaryStyle || {}
		let segments = getSocialConnectionSegments(edge)
		if(!segments){
			return
		}

		this.drawCustomEdgeWithHoverState(context, edge, () => {
			this.drawMultiplePaths(context, segments.leftVerticalSegment.x1, segments.leftVerticalSegment.y1, Math.PI / 2, (path) => {
				this.applyStyle(context, verticalLineStyle)
				this.drawLine(path, segments.leftVerticalSegment.y2 - segments.leftVerticalSegment.y1)
			})
			customConnectionRenderManager.drawConnectionSegment(context, customConnectionRenderConfig, {
				...segments.middleHorizontalSegment,
				isSelected: edge.selected(),
				showDirectionalArrow: true,
			})
			this.drawMultiplePaths(context, segments.rightVerticalSegment.x1, segments.rightVerticalSegment.y1, Math.PI / 2, (path) => {
				this.applyStyle(context, verticalLineStyle)
				this.drawLine(path, segments.rightVerticalSegment.y2 - segments.rightVerticalSegment.y1)
			})
		})
	},

	drawCustomEdgeWithHoverState(canvas, edge, callback) {
		canvas.save()
		if(edge.hasClass?.("legend-hover-dim")){
			canvas.globalAlpha = canvas.globalAlpha * LEGEND_HOVER_DIM_OPACITY
		}
		callback()
		canvas.restore()
	},

	lineStyleZigZagPrimary(lineStyle, spacing, amplitude){
		let primaryStyle = lineStyle.primaryStyle
		return {...lineStyle, primaryStyle: {...primaryStyle, zigzagSpacing: spacing, zigzagAmplitude: amplitude}}
	},

	lineStyleDottedSecondary(lineStyle){
		let secondaryStyle = lineStyle.secondaryStyle
		return {...lineStyle, secondaryStyle: this.lineStyleDotted(secondaryStyle)}
	},
	lineStyleDottedPrimary(lineStyle){
		let primaryStyle = lineStyle.secondaryStyle
		return {...lineStyle, primaryStyle: this.lineStyleDotted(primaryStyle)}
	},
	lineStyleDashedSecondary(lineStyle){
		let secondaryStyle = lineStyle.secondaryStyle
		return {...lineStyle, secondaryStyle: this.lineStyleDashed(secondaryStyle)}
	},
	lineStyleDashedPrimary(lineStyle){
		let primaryStyle = lineStyle.primaryStyle
		return {...lineStyle, primaryStyle: this.lineStyleDashed(primaryStyle)}
	},

	lineStyleDotted(lineStyle){
		return {...lineStyle, lineDash: [lineStyle.lineWidth, 3 * lineStyle.lineWidth]}
	},
	lineStyleDashed(lineStyle){
		return {...lineStyle, lineDash: [3 * lineStyle.lineWidth, 3 * lineStyle.lineWidth]}
	},

	drawCircledPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		let gapWidth = 20
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			let lineLengthHalf = (lineLength - gapWidth) / 2
			this.drawLine(path, lineLengthHalf)
			this.drawLine(path, lineLengthHalf, gapWidth + lineLengthHalf)
			path.arc(lineLengthHalf + gapWidth / 2, 0, gapWidth / 2, 0, 2 * Math.PI, false)
			if(lineStyle.isOriented){
				this.drawArrow(path, lineLength, lineStyle.primaryStyle)
			}

		})
	},

	drawDoubleCircledPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		let gapWidth = 30
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			let lineLengthHalf = (lineLength - gapWidth) / 2
			this.drawLine(path, lineLengthHalf)
			this.drawLine(path, lineLengthHalf, gapWidth + lineLengthHalf)
			path.moveTo(lineLengthHalf + 2 * gapWidth / 3, 0)
			path.arc(lineLengthHalf + gapWidth / 3, 0, gapWidth / 3, 0, 2 * Math.PI, false)
			path.moveTo(lineLengthHalf + 3 * gapWidth / 3, 0)
			path.arc(lineLengthHalf + 2 * gapWidth / 3, 0, gapWidth / 3, 0, 2 * Math.PI, false)

			if(lineStyle.isOriented){
				this.drawArrow(path, lineLength, lineStyle.primaryStyle)
			}

		})
	},

	drawMulticulturalPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		let gapWidth = 30
		let shift = -5
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			let lineLengthHalf = (lineLength - gapWidth) / 2
			this.drawLine(path, lineLength)
			path.moveTo(lineLengthHalf + gapWidth / 2, gapWidth / 2 + shift)
			path.arc(lineLengthHalf + gapWidth / 2, 0 + shift, gapWidth / 2, Math.PI /2, -Math.PI / 2, false)
			path.moveTo(lineLengthHalf + gapWidth / 2, gapWidth / 2 + shift)
			path.arc(lineLengthHalf + gapWidth / 2, gapWidth / 2 + gapWidth / 4 + shift, gapWidth / 4, -Math.PI /2, Math.PI / 2, false)
			if(lineStyle.isOriented){
				this.drawArrow(path, lineLength, lineStyle.primaryStyle)
			}

		})
	},

	drawImmigrationPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		let gapWidth = 30
		let shiftY = -8
		let shiftY2 = 8
		let shiftX = 0
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			let lineLengthHalf = (lineLength - gapWidth) / 2
			this.drawLine(path, lineLength)
			path.moveTo(lineLengthHalf + gapWidth / 2 - shiftX / 2, gapWidth / 2 + shiftY)
			path.arc(lineLengthHalf + gapWidth / 2 - shiftX / 2, 0 + shiftY, gapWidth / 2, Math.PI /2, -Math.PI / 2, false)
			path.moveTo(lineLengthHalf + gapWidth / 2 - shiftX / 2, gapWidth / 2 + shiftY)
			path.arc(lineLengthHalf + gapWidth / 2 - shiftX / 2, gapWidth / 2 + gapWidth / 4 + shiftY, gapWidth / 4, -Math.PI /2, Math.PI / 2, false)

			path.moveTo(lineLengthHalf + gapWidth / 2 + shiftX / 2, shiftY + shiftY2)
			path.arc(lineLengthHalf + gapWidth / 2 + shiftX / 2, gapWidth / 2 + shiftY + shiftY2, gapWidth / 2, -Math.PI /2, Math.PI / 2, false)
			path.moveTo(lineLengthHalf + gapWidth / 2 + shiftX / 2, shiftY + shiftY2)
			path.arc(lineLengthHalf + gapWidth / 2 + shiftX / 2, -gapWidth / 2 + gapWidth / 4 + shiftY + shiftY2, gapWidth / 4, Math.PI /2, -Math.PI / 2, false)

			if(lineStyle.isOriented){
				this.drawArrow(path, lineLength, lineStyle.primaryStyle)
			}

		})
	},

	drawCrossedPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		let crossSize = 10 * lineStyle.primaryStyle.lineWidth
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			let lineLengthHalf = lineLength / 2
			if(lineStyle.isOriented){
				this.drawOrientedLine(path, lineLength, lineStyle.primaryStyle)
			} else {
				this.drawLine(path, lineLength)
			}
			path.moveTo(lineLengthHalf - crossSize / 2, -crossSize / 2)
			path.lineTo(lineLengthHalf + crossSize / 2, crossSize / 2)
			path.moveTo(lineLengthHalf - crossSize / 2, crossSize / 2)
			path.lineTo(lineLengthHalf + crossSize / 2, -crossSize / 2)
		})
	},

	drawSquaredCrossedPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		let crossSize = 10 * lineStyle.primaryStyle.lineWidth
		this.drawCrossedPath(canvas, lineStyle, x1, y1, lineLength, angle)
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			let lineLengthHalf = lineLength / 2
			path.moveTo(lineLengthHalf + crossSize / 2, -crossSize / 2)

			path.lineTo(lineLengthHalf + crossSize / 2, crossSize / 2)
			path.lineTo(lineLengthHalf - crossSize / 2, crossSize / 2)
			path.lineTo(lineLengthHalf - crossSize / 2, -crossSize / 2)
			path.lineTo(lineLengthHalf + crossSize / 2, -crossSize / 2)
		})
	},

	drawGappedPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		let gapWidth = 3 * lineStyle.primaryStyle.lineWidth
		let gapeLineHeight = 10 * lineStyle.primaryStyle.lineWidth
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			let lineLengthHalf = (lineLength - gapWidth) / 2
			this.drawLine(path, lineLengthHalf)
			this.drawLine(path, lineLengthHalf, gapWidth + lineLengthHalf)
		}, (path) => {
			let lineLengthHalf = (lineLength - gapWidth) / 2
			this.applyStyle(canvas, lineStyle.secondaryStyle)
			path.moveTo(lineLengthHalf, -gapeLineHeight / 2)
			path.lineTo(lineLengthHalf, gapeLineHeight / 2)
			path.moveTo(lineLengthHalf + gapWidth, -gapeLineHeight / 2)
			path.lineTo(lineLengthHalf + gapWidth, gapeLineHeight / 2)

		})
	},

	drawVerticalLinesPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawVerticalLines(path, lineLength)
		})
	},

	drawVerticalLinesWithSingleLine(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.secondaryStyle)
			this.drawLine(path, lineLength)
		}, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawVerticalLines(path, lineLength)
		})
	},

	drawVerticalLinesWithDoubleLine(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.drawDoubleLine(canvas, lineStyle, x1, y1, lineLength, angle)
		}, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawVerticalLines(path, lineLength)
		})
	},

	drawSingleZigZagPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			let arrowSize = 10
			if(lineStyle.isOriented){
				arrowSize = 2 * this.drawArrow(path, lineLength, lineStyle.primaryStyle)
			}

			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawZigZag(path, lineLength, lineStyle.primaryStyle.zigzagSpacing, lineStyle.primaryStyle.zigzagAmplitude, 0, 0, arrowSize)
		})
	},

	drawDoubleZigZagPath(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			let arrowSize = 10
			if(lineStyle.isOriented){
				arrowSize = this.drawArrow(path, lineLength, lineStyle.primaryStyle)
				lineLength = lineLength - 0.8 * arrowSize
			}
			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawZigZag(path, lineLength, lineStyle.primaryStyle.zigzagSpacing, lineStyle.primaryStyle.zigzagAmplitude, 0, -MULTI_LINE_DISTANCE * lineStyle.primaryStyle.lineWidth, arrowSize)
			this.drawZigZag(path, lineLength, lineStyle.primaryStyle.zigzagSpacing, lineStyle.primaryStyle.zigzagAmplitude, 0, MULTI_LINE_DISTANCE * lineStyle.primaryStyle.lineWidth, arrowSize)

		})
	},

	drawFamilyRelationship(canvas, lineStyle, edge){
		let curveSubStyle = edge.data().lineSubType

		switch (curveSubStyle){
			case "family-marriage":
				return this.drawSocialLine(canvas, lineStyle, edge)
			case "family-divorce":
				return this.drawSocialLine(canvas, lineStyle, edge, this.drawDoubleSlash.bind(this))
			case "family-separation":
			case "family-engagement-separation":
			case "family-non-sentimental-cohabitation-separation":
			case "family-casual-separation":
			case "family-cohabitation-separation":
			case "family-legal-cohabitation-separation":
				return this.drawSocialLine(canvas, lineStyle, edge, this.drawBackSlash.bind(this))
			case "family-legal-separation":
			case "family-legal-cohabitation-legal-separation":
				return this.drawSocialLine(canvas, lineStyle, edge, this.drawSlash.bind(this))
			case "family-nullity":
				return this.drawSocialLine(canvas, lineStyle, edge, this.drawTripleSlash.bind(this))
			case "family-engagement-cohabitation":
			case "family-legal-cohabitation":
			case "family-non-sentimental-cohabitation":
			case "family-cohabitation":
				return this.drawSocialLine(canvas, lineStyle, edge, this.drawHome.bind(this), false)
			default:
				this.drawSocialLine(canvas, lineStyle, edge)
		}

	},

	drawSocialLine(canvas, lineStyle, edge, drawCentralSymbol = () => {}, drawBehindCentralSymbol = true) {
		let segments = getSocialConnectionSegments(edge)
		if(!segments){
			return
		}
		let {
			leftVerticalSegment,
			middleHorizontalSegment,
			rightVerticalSegment,
			lineLength,
		} = segments
		let symbolSize = FAMILY_SYMBOL_SIZE * lineStyle.primaryStyle.lineWidth

		this.drawMultiplePaths(canvas, leftVerticalSegment.x1, leftVerticalSegment.y1, Math.PI / 2, (path) => {
			this.applyStyle(canvas, lineStyle.secondaryStyle)
			this.drawLine(path, leftVerticalSegment.y2 - leftVerticalSegment.y1)
		})
		this.drawMultiplePaths(canvas, middleHorizontalSegment.x1, middleHorizontalSegment.y1, 0, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
				if(drawBehindCentralSymbol){
					this.drawLine(path, lineLength)
				} else {
					let length = (lineLength - symbolSize) / 2
					this.drawLine(path, length)
					this.drawLine(path, length, length + symbolSize)
				}
		}, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			canvas.setLineDash([])
			drawCentralSymbol(path, symbolSize, lineStyle.primaryStyle, (lineLength) / 2)
		})
		this.drawMultiplePaths(canvas, rightVerticalSegment.x1, rightVerticalSegment.y1, Math.PI / 2, (path) => {
			this.applyStyle(canvas, lineStyle.secondaryStyle)
			this.drawLine(path, rightVerticalSegment.y2 - rightVerticalSegment.y1)
		})
	},

	getEdgeConnectionCategory(edgeData = {}) {
		return getGenogramConnectionCategoryByEdgeData(edgeData)
	},

	drawHome(path, size, lineStyle, xShift = 0, yShift = 0){
		let halfSize = size / 2
		let roofHeight = 10
		let wallHeight = (size - roofHeight) / 2
		path.moveTo(xShift - halfSize, yShift + wallHeight)
		path.lineTo(xShift - halfSize, yShift - wallHeight)
		path.lineTo(xShift, yShift - wallHeight - roofHeight)
		path.lineTo(xShift + halfSize, yShift - wallHeight)
		path.lineTo(xShift + halfSize, yShift + wallHeight)
		path.closePath()
	},


	drawSlash(path, size, lineStyle, xShift = 0, yShift = 0){
		let halfSize = size / 2
		path.moveTo(xShift - halfSize, yShift + halfSize)
		path.lineTo(xShift + halfSize, yShift - halfSize)
	},
	drawDoubleSlash(path, size, lineStyle, xShift = 0, yShift = 0){
		let halfDistance = MULTI_LINE_DISTANCE * lineStyle.lineWidth
		this.drawSlash(path, size, lineStyle, xShift - halfDistance, yShift)
		this.drawSlash(path, size, lineStyle, xShift + halfDistance, yShift)
	},
	drawTripleSlash(path, size, lineStyle, xShift = 0, yShift = 0){
		let halfDistance = 2 * MULTI_LINE_DISTANCE * lineStyle.lineWidth
		this.drawSlash(path, size, lineStyle, xShift - halfDistance, yShift)
		this.drawSlash(path, size, lineStyle, xShift, yShift)
		this.drawSlash(path, size, lineStyle, xShift + halfDistance, yShift)
	},
	drawBackSlash(path, size, lineStyle, xShift = 0, yShift = 0){
		let halfSize = size / 2
		path.moveTo(xShift - halfSize, yShift - halfSize)
		path.lineTo(xShift + halfSize, yShift + halfSize)
	},

	drawZigZagWithSingleLine(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			let arrowSize = 10
			if(lineStyle.isOriented){
				arrowSize = 2 * this.drawArrow(path, lineLength, lineStyle.primaryStyle)
			}

			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawZigZag(path, lineLength, lineStyle.primaryStyle.zigzagSpacing, lineStyle.primaryStyle.zigzagAmplitude, 0, 0, arrowSize)
		}, (path) => {
			this.applyStyle(canvas, lineStyle.secondaryStyle)
			this.drawLine(path, lineLength)
			// this.drawSingleLine(canvas, lineStyle, x1, y1, lineLength, angle)
		})
	},

	drawZigZagWithDoubleLine(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			let arrowSize = lineStyle.isOriented ? 5 : 0
			this.drawDoubleLine(canvas, lineStyle, x1, y1, lineLength - arrowSize, angle)
		}, (path) => {
			let arrowSize = 10
			if(lineStyle.isOriented){
				arrowSize = 2 * this.drawArrow(path, lineLength, lineStyle.primaryStyle)
			}
			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawZigZag(path, lineLength, lineStyle.primaryStyle.zigzagSpacing, lineStyle.primaryStyle.zigzagAmplitude, 0, 0, arrowSize)
		})
	},

	drawZigZagWithTripleLine(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			let arrowSize = lineStyle.isOriented ? 8 : 0
			this.drawTripleLine(canvas, lineStyle, x1, y1, lineLength - arrowSize, angle)
		}, (path) => {
			let arrowSize = 10
			if(lineStyle.isOriented){
				arrowSize = 2 * this.drawArrow(path, lineLength, lineStyle.primaryStyle)
			}

			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawZigZag(path, lineLength, lineStyle.primaryStyle.zigzagSpacing, lineStyle.primaryStyle.zigzagAmplitude, 0, 0, arrowSize)
		})
	},

	drawSingleLine(canvas, lineStyle, x1, y1, lineLength, angle, xShift = 0, yShift = 0) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			this.drawLine(path, lineLength, xShift, yShift)
		}, (path) => {
			if(lineStyle.isOriented){
				this.applyStyle(canvas, lineStyle.secondaryStyle)
				this.drawArrow(path, lineLength, lineStyle.secondaryStyle)
			}

		})
	},
	drawOrientedLinePath(canvas, lineStyle, x1, y1, lineLength, angle, xShift = 0, yShift = 0) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.primaryStyle)
			if(lineStyle.isOriented){
				this.drawOrientedLine(path, lineLength, lineStyle.primaryStyle)
			} else {
				this.drawLine(path, lineLength)
			}
		})
	},

	drawDoubleLine(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.secondaryStyle)
			this.drawLine(path, lineLength, 0, -MULTI_LINE_DISTANCE / 2 * lineStyle.secondaryStyle.lineWidth)
			this.drawLine(path, lineLength, 0, MULTI_LINE_DISTANCE / 2  * lineStyle.secondaryStyle.lineWidth)
		})
	},
	drawTripleLine(canvas, lineStyle, x1, y1, lineLength, angle) {
		this.drawMultiplePaths(canvas, x1, y1, angle, (path) => {
			this.applyStyle(canvas, lineStyle.secondaryStyle)
			this.drawLine(path, lineLength, 0, -MULTI_LINE_DISTANCE * lineStyle.secondaryStyle.lineWidth)
			this.drawLine(path, lineLength, 0, 0)
			this.drawLine(path, lineLength, 0, MULTI_LINE_DISTANCE * lineStyle.secondaryStyle.lineWidth)
		})
	},

	drawMultiplePaths(canvas, x1, y1, angle, ...pathsCallbacks) {
		pathsCallbacks.forEach(callback => {
			let path = new Path2D()
			canvas.save()
			callback(path)
			this.drawPathOnCanvas(canvas, path, x1, y1, angle, 0, 0)
			canvas.restore()
		})
	},

	applyStyle(canvas, style = {}) {
		let initialGlobalAlpha = canvas.globalAlpha
		canvas.strokeStyle = (style.isSelected ? style.strokeStyleSelected : style.strokeStyle) || canvas.strokeStyle
		canvas.lineWidth = (style.isSelected ? style.lineWidthSelected || style.lineWidth : style.lineWidth) || canvas.lineWidth
		if(style.isSelected){
			// canvas.shadowColor = "black";
			// canvas.shadowBlur = 5;
			canvas.lineWidth = canvas.lineWidth * 1.6
		}
		if(style.opacity != null){
			canvas.globalAlpha = initialGlobalAlpha * style.opacity
		}
		if(style.lineDash){
			canvas.setLineDash(style.lineDash)
		} else {
			canvas.setLineDash([])
		}
		// console.log("applyStyle: ", style)
	},

	drawZigZag(path, lineLength, zigzagSpacing = 10, oneZigZagLength = 12, xShift = 0, yShift = 0, zigZagStraightLength = 10) {

		let straightLengthWhenZigZag = zigZagStraightLength
		let zigZagLength = lineLength - straightLengthWhenZigZag

		let zx = 0
		path.moveTo(zx + xShift, yShift)
		for (let n = 0; zx < zigZagLength; n++) {
			zx = ((n + 1) * zigzagSpacing)
			const zy = (n % 2 == 0) ? -oneZigZagLength : oneZigZagLength
			path.lineTo(zx + xShift, zy + yShift)
		}
		path.lineTo(lineLength - (straightLengthWhenZigZag / 2) + xShift, yShift)
		path.lineTo(lineLength + xShift, yShift)

	},

	drawWave(path, lineLength, zigzagSpacing = 10, oneZigZagLength = 12, xShift = 0, yShift = 0, zigZagStraightLength = 10) {

		let straightLengthWhenZigZag = zigZagStraightLength
		let zigZagLength = lineLength - straightLengthWhenZigZag

		let zx = 0
		path.moveTo(zx + xShift, yShift)
		let preX = xShift
		let preY = yShift
		for (let n = 0; zx < zigZagLength; n++) {
			zx = ((n + 1) * zigzagSpacing)
			const zy = (n % 2 == 0) ? -oneZigZagLength : oneZigZagLength
			// path.lineTo(zx + xShift, zy + yShift)
			let newX = zx + xShift
			let newY = zy + yShift
			path.bezierCurveTo(preX+(newX - preX)/2, -zy + yShift, preX+(newX - preX)/2, zy + yShift, newX, newY)
			preX = newX
			preY = newY
		}
		let newX = lineLength - (straightLengthWhenZigZag / 2) + xShift
		path.bezierCurveTo(preX+(newX - preX)/2, preY, preX+(newX - preX)/2, 0, newX, yShift)
		path.lineTo(lineLength + xShift, yShift)

	},

	drawVerticalLines(path, lineLength, spacing = 10, oneLineLength = 20) {

		let pathLength = lineLength - spacing

		let zx = spacing
		for (let n = 0; zx < pathLength; n++) {
			zx = ((n + 1) * spacing)
			path.moveTo(zx, -oneLineLength / 2)
			path.lineTo(zx, oneLineLength / 2)
		}

	},

	drawLine(path, lineLength, xShift = 0, yShift = 0) {
		path.moveTo(xShift, yShift)
		path.lineTo(lineLength + xShift, yShift)
	},

	drawOrientedLine(path, lineLength, lineStyle, xShift = 0, yShift = 0) {
		path.moveTo(xShift, yShift)
		path.lineTo(lineLength + xShift, yShift)
		this.drawArrow(path, lineLength, lineStyle, xShift, yShift)
	},

	drawArrow(path, lineLength, lineStyle, xShift = 0, yShift = 0) {

		let arrowSize = ARROW_BASE_SIZE * lineStyle.lineWidth

		path.moveTo(lineLength + xShift - arrowSize, yShift + arrowSize)
		path.lineTo(lineLength + xShift, yShift)
		path.moveTo(lineLength + xShift - arrowSize, yShift - arrowSize)
		path.lineTo(lineLength + xShift, yShift)
		return arrowSize
	},

	drawPathOnCanvas(canvas, path, x = 0, y = 0, angle = 0, xShift = 0, yShift = 0) {
		canvas.translate(x, y)
		canvas.rotate(angle)
		canvas.translate(xShift, yShift)
		canvas.stroke(path)
	},

	drawNodeLabels(context, node){

		//boundingBoxImpl
		// console.trace("drawNodeLabels: context = ", context)
		let data = node.data()
		var nodeW = node.width() + 2;
		var nodeH = node.height() + 2;
		console.log("node.outerWidth = ", node.outerWidth())
		context.save()

		// context.beginPath()
		// context.moveTo(0, 0)
		// context.lineTo(nodeW * 2, 0)
		// context.lineTo(nodeW * 2, nodeH * 2)
		// context.lineTo(0, nodeH * 2)
		// context.closePath();
		// context.clip()

		context.fillStyle = "black"
		context.textAlign = "center"
		context.fillText('Hello world', 40, 20);

		context.restore()
	},

	drawOverlaySigns(context, node, shiftXY){
		let data = node.data()
		var nodeW = node.outerWidth();
		var nodeH = node.outerHeight();

		if(data.isPassedAway){
			// console.trace("drawOverlaySigns: passed away context = ", context, ",)
			this.drawMultiplePaths(context, shiftXY.x, shiftXY.y, 0, (path) => {
				context.strokeStyle = "rgba(20, 20, 20, 0.9)"
				context.lineWidth = 4
				path.moveTo(0, 0)
				path.lineTo(nodeW, nodeH)
				path.moveTo(0, nodeH)
				path.lineTo(nodeW, 0)
			})
		}

	},

	drawHealthConditions(context, node, shiftXY){
		let {tags} = node.data()
		// console.log("drawNode: tags = ", tags)
		console.log("drawHealthConditions1: node = ", node)
		if(!tags || !tags.length){
			return
		}

		console.log("drawHealthConditions: node = ", node)
		var nodeW = node.outerWidth();
		var nodeH = node.outerHeight();

		let l = shiftXY.x
		let r = shiftXY.x + nodeW
		let t = shiftXY.y
		let b = shiftXY.y + nodeH


		context.save();

		context.beginPath()
		context.moveTo(l, t)
		context.lineTo(r, t)
		context.lineTo(r, b)
		context.lineTo(l, b)
		context.closePath();
		context.clip()


		var data = []//[25, 25, 25]; // If you add more data values make sure you add more colors
		var colors = []//['red', 'green', 'blue']; // Colors of each slice

		let segmentsCount = Math.min(tags.length, 10)
		let segmentSize = Math.min(25, 75 / segmentsCount) // we draw 75% max with up to 25% per segment
		for(let i =0; i < segmentsCount; ++i){
			let tag = tags[i]
			data.push(segmentSize)
			colors.push(tag.color)
		}


		// let pos =  node.position();
		// var radius = Math.min(nodeW, nodeH) / 2; // must fit in node
		// var x = shiftXY.x//pos.x / 2;
		// var y = shiftXY.y//pos.y / 2;
		// let scale = 2
		//
		// if(node.data().type.startsWith('ellipse')){
		// 	x += radius
		// 	y += radius
		// 	scale = 1
		// }
		//
		// context.translate(x, y)
		// context.scale(scale, scale)

		let pos =  node.position();
		var radius = Math.min(nodeW, nodeH) / 2; // must fit in node
		var x = radius//pos.x / 2;
		var y = radius//pos.y / 2;

		let shiftX = shiftXY.x
		let shiftY = shiftXY.y
		let scale = 1

		let nodeType = node.data().type || ""
		let isEllipse = nodeType.startsWith('ellipse') || nodeType.startsWith('female')


		if(!isEllipse){
			shiftX -= radius
			shiftY -= radius
			scale = 2
		}
		context.translate(shiftX, shiftY)
		context.scale(scale, scale)


		let lastPercent = 0
		for (var i = 0; i < data.length; i++) {
			var size = data[i]
			var color = colors[i]
			var opacity = 0.5//node.pstyle('pie-' + i + '-background-opacity').value * nodeOpacity;
			var percent = size / 100; // map integer range [0, 100] to [0, 1]
			// percent can't push beyond 1

			if (percent + lastPercent > 1) {
				percent = 1 - lastPercent;
			}

			var angleStart = 1.5 * Math.PI + 2 * Math.PI * lastPercent; // start at 12 o'clock and go clockwise

			var angleDelta = 2 * Math.PI * percent;
			var angleEnd = angleStart + angleDelta; // ignore if
			// - zero size
			// - we're already beyond the full circle
			// - adding the current slice would go beyond the full circle

			if (size === 0 || lastPercent >= 1 || lastPercent + percent > 1) {
				continue;
			}



			context.beginPath();
			context.moveTo(x, y);
			context.arc(x, y, radius, angleStart, angleEnd);
			context.closePath();
			context.fillStyle = color
			context.fill();
			lastPercent += percent;

		}
		context.restore()
	}

}
// }


// GenogramRenderer.prototype.constructor = GenogramRenderer
// $.extend(PricingRenderer, CanvasRenderer);
console.log('GenogramRenderer.prototype = ', GenogramRenderer.prototype)

export default GenogramRenderer
